import Form from "./components/Form";
import SearchResults from "./components/SearchResults";
import Pagination from "./components/Pagination";
import "./App.css";
import React, { useState, useEffect } from "react";
import API from "./api";

export const LangContext = React.createContext();

function App() {
  const [posts, setPosts] = useState({ info: [], data: [] });
  const [loading, setLoading] = useState(false);
  const [initLoad, setInitLoad] = useState(false);
  const [selected, setSelected] = useState([]);
  const [lang, setLang] = useState("sk");

  useEffect(() => {
    let originalLang = document.getElementsByClassName("wpml-ls-native");
    if (originalLang.length !== 0) {
      let newLang = originalLang[0].getAttribute("lang") === "en" ? "sk" : "en";
      setLang(newLang);
    }
  }, []);

  function getPosts(data) {
    setInitLoad(true);
    setLoading(true);
    API.post(`${lang === "en" ? "en/" : ""}wp-json/react/v1/search`, data)
      .then((res) => {
        setPosts(res.data);
        setLoading(false);
      })
      .catch(() => {
        const postsError = { ...posts };
        postsError.data = false;
        setPosts(postsError);
        setLoading(false);
      });
  }

  function onSubmitFormHandler(e, page = 1) {
    e.preventDefault();
    const searchTerm = document.getElementById("search-term").value;
    const category = selected.map((cat) => {
      return cat.value;
    });

    let data = {};

    if (searchTerm !== "") {
      data.s = searchTerm;
    }

    if (category !== []) {
      data.cat = category;
    }

    data.p = page;

    getPosts(data);
  }

  function onPageClickHandler(e) {
    const page = e.target.getAttribute("data-page")
      ? e.target.getAttribute("data-page")
      : 1;
    onSubmitFormHandler(e, page);
  }

  function multipleSelectHandler(data) {
    setSelected(data);
  }

  return (
    <div className="App">
      <LangContext.Provider value={lang}>
        <Form
          onSubmitForm={onSubmitFormHandler}
          onMultipleSelect={multipleSelectHandler}
          selectedData={selected}
        />

        {initLoad && <SearchResults data={posts.data} loading={loading} />}
      </LangContext.Provider>

      <Pagination data={posts.info} onPageClick={onPageClickHandler} />
    </div>
  );
}

export default App;
